module.exports = __webpack_public_path__ + "img/logo-lde.61c0080f.png";